"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable react/jsx-no-useless-fragment */
const react_1 = __importStar(require("react"));
const UI_1 = require("~/components/UI");
const consts_1 = require("~/store/consts");
const react_redux_1 = require("react-redux");
const react_i18next_1 = require("react-i18next");
const selectors_1 = require("~/store/widgets/content/itemReplacement/selectors");
const types_1 = require("~/store/types");
const RadioButton_1 = __importDefault(require("~/components/common/controls/RadioButton"));
const Image_1 = require("~/components/UI/Image");
// eslint-disable-next-line import/namespace
const utils_1 = require("~/utils/utils");
const redux_1 = require("redux");
const actions_1 = require("~/store/actions");
const useWindowDimensions_1 = __importDefault(require("~/hooks/useWindowDimensions"));
const selectors_2 = require("~/store/selectors");
const ReplaceObjectsCommand_1 = __importDefault(require("~/components/Cad3d/commands/ReplaceObjectsCommand"));
const Viewer_1 = __importDefault(require("~/components/Cad3d/Viewer"));
const ItemReplacementWidget_scss_1 = __importDefault(require("./ItemReplacementWidget.scss"));
function ItemReplacementWidget() {
    var _a;
    // Hooks
    const { t } = (0, react_i18next_1.useTranslation)('widgets');
    const { availableReplacements, itemToBeReplaced, typeOfItemsToReplace } = (0, react_redux_1.useSelector)(selectors_1.selectItemReplacementData);
    const [replaceAll, setReplaceAll] = (0, react_1.useState)(false);
    const [selectedReplacement, setSelectedReplacement] = (0, react_1.useState)(availableReplacements === null || availableReplacements === void 0 ? void 0 : availableReplacements[0]);
    const { bom } = (0, react_redux_1.useSelector)(selectors_2.selectBOM);
    const { height: windowHeight, width: windowWidth } = (0, useWindowDimensions_1.default)();
    const currentProjectId = (0, react_redux_1.useSelector)(selectors_2.selectCurrentProjectId);
    // Action dispatchers
    const { dispatchToggleWidget, dispatchSetItemsReplacementDetails } = (0, redux_1.bindActionCreators)({
        dispatchToggleWidget: actions_1.toggleWidget,
        dispatchSetItemsReplacementDetails: actions_1.setItemsReplacementDetails,
    }, (0, react_redux_1.useDispatch)());
    // Effects
    (0, react_1.useEffect)(() => {
        setSelectedReplacement(availableReplacements[0]);
    }, [availableReplacements]);
    // Component data
    const getTitleForItemType = (0, react_1.useCallback)(() => {
        const replace = t('item-replacement.title.prefix');
        let item = '';
        switch (typeOfItemsToReplace) {
            case types_1.ITEM_TYPE.EXTRUSION:
                item = t('item-replacement.title.extrusionProfile');
                break;
            case types_1.COMPONENT_TYPE.PANEL:
                item = t('item-replacement.title.panel');
                break;
            case types_1.COMPONENT_TYPE.TSLOT_COVER:
                item = t('item-replacement.title.tSlotCover');
                break;
            default:
                break;
        }
        return `${replace} ${item}`;
    }, [t, typeOfItemsToReplace]);
    const getUUIDsOfAllReplaceableParts = (0, react_1.useCallback)(() => {
        var _a;
        const uuids = [];
        (_a = bom === null || bom === void 0 ? void 0 : bom.groups) === null || _a === void 0 ? void 0 : _a.forEach((group) => {
            group.items.forEach((item) => {
                if (item.item_number === (itemToBeReplaced === null || itemToBeReplaced === void 0 ? void 0 : itemToBeReplaced.item_number) && item.uuid) {
                    uuids.push(...item.uuid);
                }
            });
        });
        return uuids;
    }, [bom === null || bom === void 0 ? void 0 : bom.groups, itemToBeReplaced === null || itemToBeReplaced === void 0 ? void 0 : itemToBeReplaced.item_number]);
    const isReplacementSelected = (0, react_1.useCallback)((replacement, index) => {
        return (!selectedReplacement && index === 0) || replacement.item_number === (selectedReplacement === null || selectedReplacement === void 0 ? void 0 : selectedReplacement.item_number);
    }, [selectedReplacement]);
    const isLoading = (0, react_1.useMemo)(() => !availableReplacements || !itemToBeReplaced || !typeOfItemsToReplace, [availableReplacements, itemToBeReplaced, typeOfItemsToReplace]);
    // Handlers
    const onSelectReplacement = (0, react_1.useCallback)((replacement) => {
        setSelectedReplacement(replacement);
    }, []);
    const closeWidget = (0, react_1.useCallback)(() => {
        setReplaceAll(false);
        dispatchSetItemsReplacementDetails({
            typeOfItemsToReplace: '',
            itemToBeReplaced: null,
            availableReplacements: [],
        });
        dispatchToggleWidget({
            widgetName: consts_1.WIDGETS.ITEM_REPLACEMENT_WIDGET,
            show: false,
        });
    }, [dispatchSetItemsReplacementDetails, dispatchToggleWidget]);
    const handleClose = (0, react_1.useCallback)(() => {
        closeWidget();
    }, [closeWidget]);
    const handleReplace = (0, react_1.useCallback)(() => {
        if (!selectedReplacement || !itemToBeReplaced || !currentProjectId) {
            return;
        }
        const selectedObjects = Viewer_1.default.instance.selectedObjects;
        const uuidsForReplacement = replaceAll
            ? getUUIDsOfAllReplaceableParts()
            : selectedObjects.map((object) => object.uuid);
        if (!selectedObjects.length || !uuidsForReplacement.length) {
            return;
        }
        const itemReplacementCommand = new ReplaceObjectsCommand_1.default(selectedObjects[0].partDetails.itemNumber, selectedReplacement.item_number, uuidsForReplacement, typeOfItemsToReplace);
        itemReplacementCommand.executeWithHistory();
        closeWidget();
    }, [
        selectedReplacement,
        itemToBeReplaced,
        currentProjectId,
        replaceAll,
        getUUIDsOfAllReplaceableParts,
        typeOfItemsToReplace,
        closeWidget,
    ]);
    // Sub-components
    const availableReplacement = (0, react_1.useCallback)((replacement, index) => {
        var _a;
        return (react_1.default.createElement("div", { className: ItemReplacementWidget_scss_1.default.part, key: replacement.item_number },
            react_1.default.createElement(RadioButton_1.default, { onSelect: () => onSelectReplacement(replacement), selected: isReplacementSelected(replacement, index) },
                react_1.default.createElement(Image_1.Image, { className: ItemReplacementWidget_scss_1.default.image, src: (0, utils_1.formatAssetsURL)((_a = replacement.image) === null || _a === void 0 ? void 0 : _a.url) }),
                react_1.default.createElement("div", { className: ItemReplacementWidget_scss_1.default.itemNumber }, `#${replacement.item_number}`),
                react_1.default.createElement("span", { className: ItemReplacementWidget_scss_1.default.separator }, "-"),
                react_1.default.createElement("div", { className: ItemReplacementWidget_scss_1.default.description }, replacement.description))));
    }, [isReplacementSelected, onSelectReplacement]);
    const sectionHeading = (0, react_1.useCallback)((headingText) => react_1.default.createElement("div", { className: ItemReplacementWidget_scss_1.default.heading }, headingText), []);
    return (react_1.default.createElement(UI_1.Widget, { widgetName: consts_1.WIDGETS.ITEM_REPLACEMENT_WIDGET, defaultPosition: {
            x: (windowWidth - 343) / 2,
            y: (windowHeight - 478) / 2,
        }, defaultSize: {
            width: 343,
            height: 478,
        }, minSize: {
            width: 343,
            height: 478,
        } },
        react_1.default.createElement("div", { className: ItemReplacementWidget_scss_1.default.content }, !isLoading ? (react_1.default.createElement("div", { className: ItemReplacementWidget_scss_1.default.container },
            react_1.default.createElement("header", null,
                react_1.default.createElement("div", { className: ItemReplacementWidget_scss_1.default.title }, getTitleForItemType())),
            react_1.default.createElement("main", null,
                react_1.default.createElement("section", { className: ItemReplacementWidget_scss_1.default.replacementPart },
                    sectionHeading(t('item-replacement.replacementPart.heading')),
                    react_1.default.createElement("div", { className: ItemReplacementWidget_scss_1.default.part },
                        react_1.default.createElement(Image_1.Image, { className: ItemReplacementWidget_scss_1.default.image, src: (0, utils_1.formatAssetsURL)((_a = itemToBeReplaced === null || itemToBeReplaced === void 0 ? void 0 : itemToBeReplaced.image) === null || _a === void 0 ? void 0 : _a.url) }),
                        react_1.default.createElement("div", { className: ItemReplacementWidget_scss_1.default.itemNumber }, `#${itemToBeReplaced === null || itemToBeReplaced === void 0 ? void 0 : itemToBeReplaced.item_number}`),
                        react_1.default.createElement("span", { className: ItemReplacementWidget_scss_1.default.separator }, "-"),
                        react_1.default.createElement("div", { className: ItemReplacementWidget_scss_1.default.description }, itemToBeReplaced === null || itemToBeReplaced === void 0 ? void 0 : itemToBeReplaced.description))),
                react_1.default.createElement("section", { className: ItemReplacementWidget_scss_1.default.replacementOptions },
                    sectionHeading(t('item-replacement.replacementOptions.heading')),
                    react_1.default.createElement("div", { className: ItemReplacementWidget_scss_1.default.replaceAll },
                        react_1.default.createElement(UI_1.Checkbox, { label: `${t('item-replacement.replacementOptions.replaceAllPrefix')} #${itemToBeReplaced === null || itemToBeReplaced === void 0 ? void 0 : itemToBeReplaced.item_number}`, checked: replaceAll, onCheck: setReplaceAll }))),
                react_1.default.createElement("section", { className: ItemReplacementWidget_scss_1.default.partsToReplace },
                    sectionHeading(t('item-replacement.partsToReplace.heading')),
                    react_1.default.createElement(UI_1.Scrollable, { scrollbar: true },
                        react_1.default.createElement(react_1.default.Fragment, null, availableReplacements === null || availableReplacements === void 0 ? void 0 : availableReplacements.map((replacement, index) => availableReplacement(replacement, index)))))),
            react_1.default.createElement("footer", null,
                react_1.default.createElement(UI_1.Button, { onClick: handleClose, variant: "default" }, t('item-replacement.actions.close')),
                react_1.default.createElement(UI_1.Button, { onClick: handleReplace, variant: "primary" }, t('item-replacement.actions.replace'))))) : (t('loading')))));
}
exports.default = ItemReplacementWidget;
